
<ngx-slick-carousel class="carousel" [config]="slideConfig">
  <div style="height: 100px;" ngxSlickItem *ngFor="let partner of partners">
    <a style="height: 100%;" [routerLink]="['/partners/'+ partner.key]">
      <img [src]="partner.logoUrl"  alt="logo client">
    </a>
  </div>
</ngx-slick-carousel>
